// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "customer-260420-1/static/css/" + chunkId + "." + {"1253":"5a403dd4","2280":"5132f0ec","2395":"5a403dd4","2425":"5a403dd4","2473":"5132f0ec","2918":"5132f0ec","2982":"07a465cd","4767":"5a403dd4","7010":"5132f0ec"}[chunkId] + ".chunk.css";
};